import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import IAuditoria from "../../../entities/IAuditoria";
import { ITipoUnidadAuditar } from "../../../entities/ITipoUnidadAuditar";
import { shortDate } from "../../../helpers/dateHelper";
import { getAPI } from "../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import { API_ADMIN_TIPO_UNIDAD_AUDITAR, ROW_COUNT_MAX, URL_SUPPORT } from "../../../helpers/variableHelper";
interface IDetalleAuditoriaProps {
  callbackClose: () => void;
  show: boolean;
  auditoriaSeleccionada?: IAuditoria | null;
  token: string;
  is_Test?: boolean;
}
export default function DetalleAuditoria({ callbackClose, show, auditoriaSeleccionada, token, is_Test }: IDetalleAuditoriaProps) {
  const [listUnidadesAuditar, setListUnidadesAuditar] = useState<Array<ITipoUnidadAuditar>>([]);
  usePromiseEffect(async () => {}, [listUnidadesAuditar]);

  return !auditoriaSeleccionada ? (
    <div></div>
  ) : (
    <Offcanvas
      show={show}
      onShow={async () => {
        console.log(auditoriaSeleccionada?.TIPO_AUDITORIA);
        let paramsActive = {
          PAGINA: 1,
          PAGINADO: ROW_COUNT_MAX,
          ORDENADOPOR: `ID`,
          ORIENTACION: "DESC",
          ACTIVO: true,
          //ID: 93,
          ID_AUDITORIA: auditoriaSeleccionada?.ID,
        };
        let resultAllUnidadAuditar = is_Test
          ? { data: [1, 2, 3, 4] }
          : (
              await getAPI(
                `${URL_SUPPORT}${API_ADMIN_TIPO_UNIDAD_AUDITAR}/getall`,
                { Authorization: `Bearer ${token}` },
                {
                  ...paramsActive,
                  TIPO_AUDITORIA: auditoriaSeleccionada?.TIPO_AUDITORIA,
                  ORDENADOPOR: "ID",
                  ACTIVO: true,
                }
              )
            ).result;
        setListUnidadesAuditar(resultAllUnidadAuditar.data);
      }}
      onHide={() => {
        setListUnidadesAuditar([]);
        callbackClose();
      }}
      placement={"end"}
      className="w-50">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Ver Auditoría</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="offcanvas-body pt-0">
          <div className="row ajusteInput">
            <div className="col-12">
              <label>Código de Auditoría</label>
              <p className="mb-2">{auditoriaSeleccionada.CORRELATIVO}</p>
              <label>Tipo Auditoría</label>
              <p className="mb-2">{auditoriaSeleccionada.TIPO_AUDITORIA}</p>
              <label>Estado Auditoría</label>
              <p className="mb-2">{auditoriaSeleccionada.ESTADO}</p>
              <label>Ámbito de Auditoría</label>
              <div className="mb-2">
                {listUnidadesAuditar.map((ua) => {
                  return (
                    <div key={ua.ID} className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value="option2"
                        disabled
                        defaultChecked={auditoriaSeleccionada?.UNIDAD_A_AUDITAR?.includes(ua.ID as number)}
                      />
                      <label className="form-check-label">{ua.NOMBRE}</label>
                    </div>
                  );
                })}
              </div>
              <label>Objetivo, Alcance y Exclusiones</label>
              <p className="mb-2">{auditoriaSeleccionada.OBJETIVO_ALCANCE_EXCLUSIONES}</p>
              <label>Vicepresidencia</label>
              <p className="mb-2">{auditoriaSeleccionada.VICEPRESIDENCIA}</p>
              <label>Gerencia/Subgerencia</label>
              <p className="mb-2">{auditoriaSeleccionada.GERENCIA_SUBGERENCIA}</p>
              <label>Unidad/Proyecto</label>
              <p className="mb-2">{auditoriaSeleccionada.UNIDAD_PROYECTO}</p>
              <div className="row">
                <div className="col-4">
                  <label>Fecha Desde</label>
                  <p className="mb-2">{shortDate(auditoriaSeleccionada.FECHA_DESDE)}</p>
                </div>
                <div className="col-8">
                  <label>Fecha Hasta</label>
                  <p className="mb-2">{shortDate(auditoriaSeleccionada.FECHA_HASTA)}</p>
                </div>
              </div>
              <label>Responsable del área a Auditar</label>
              <p className="mb-2">{auditoriaSeleccionada.RESPONSABLE_AREA_DISPLAY}</p>
              <label>Auditor Líder</label>
              <p className="mb-2">{auditoriaSeleccionada.AUDITOR_LIDER_DISPLAY}</p>
              <label>Auditores Participantes</label>
              <p className="mb-2">{auditoriaSeleccionada.AUDITORES_ACOMPANANTES_DISPLAY}</p>
              <label>Cuenta con Auditor Externo</label>
              <p className="mb-2">{auditoriaSeleccionada.AUDITOR_EXTERNO ? "Sí" : "No"}</p>
            </div>

            <div className="col-12 mb-4 mt-2">
              <button
                type="button"
                className="btn btn-primary btn-sm"
                data-bs-dismiss="offcanvas"
                onClick={() => {
                  callbackClose();
                }}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
